export default __webpack_public_path__ + "static/media/2_step.d18439c4.svg";